export default __webpack_public_path__ + "static/media/logo_full.390076c7.png";